
import Selector from 'vux/src/components/selector/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import XAddress from 'vux/src/components/x-address/index.vue'


export default {
components: {
XButton
},
data(){
return {
iden:'',
cont:'',
orderDetail:{}
}
},
methods:{
confirm () {

var that = this
var obj = {
role: this.iden,
reason: this.cont
}
console.log(obj)
var header = {
headers:{
token:localStorage.getItem('token'),
opid:localStorage.getItem('userid')
}
}
console.log(header)
if(this.cont != ''){
this.$http.put('/api/v1/normalrepairs/'+ this.orderDetail.seq +'/cancel',obj,header)
.then(function(res){
console.log(res)
that.$router.push({name:'normalrepairslist'})
})
.catch(function(error){
console.log(error.response)
that.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
} else {
this.$vux.toast.show({
text: '描述信息不能为空',
type: 'cancel',
time: '1000'
})
}


}
},
created(){
this.orderDetail = this.$route.params.obj
let that = this
let opid = localStorage.getItem('userid');
var header = {
headers:{
token:localStorage.getItem('token'),
opid:opid
}
}
this.$http.get('/api/v1/accounts/'+opid,header)
.then(function(res){
console.log(res)
for (let i=0;i<res.data.length;i++){
if(res.data[i].type == 'INDV'){
that.iden = 'INDV'
}
if(res.data[i].type == 'ENTP'){
that.iden = 'ENTP'
}
}
})
.catch( error => {
that.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
}
}



// WEBPACK FOOTER //
// ./src/components/cancelCause.vue